module.exports = __webpack_public_path__ + "img/gdid_logo.c1db414e.png";